import type { Locale } from './constants'

/**
 * 달을 그 언어의 달 이름으로 — "month 10"·"10/2026"·"mes 10" 대신 "October"·"octubre".
 * 한·중·일은 숫자 그대로 ("10" → 틀이 "10월"·"10月" 로 붙인다). `start` 면 첫 글자를 대문자로 (es·pt 는 달 이름이 소문자다).
 */
export function monthWord(locale: Locale, month: number, start = false): string {
  if (locale === 'ko' || locale === 'ja' || locale.startsWith('zh')) return String(month)
  const name = intlMonthName(locale, month)
  return start ? name.charAt(0).toLocaleUpperCase(locale) + name.slice(1) : name
}

/** 그 언어가 쓰는 달 이름 그대로 (ko "3월" · en "March" · es "marzo") — 대소문자는 손대지 않는다 */
export function intlMonthName(locale: Locale, month: number): string {
  return new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2000, month - 1, 1)))
}
